import React from 'react';
import './career.scss';
import Breadcrumb from '../../shared/breadcrumb/breadcrumb.js';

export function Career() {
  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/career', text: 'Вакансии' }
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <h1>Вакансии</h1>
        </div>
        <div>
          <div className="card add_bottom_45">
            <div className="card-body">
              <p>К сожалению, на текущий момент открытых вакансий нет.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Career;
